import { Box, HStack, Input, Text, Textarea } from "@chakra-ui/react";
import { convertDateReservation } from "lib/utils/regular";
import { ChangeEvent } from "react";
import SubTitle from "routes/Order/components/SubTitle";

interface ReservationInfoProps {
    title?: string;
    reservationDate: string;
    isFace: boolean;
    comments: string;
    callbackReservation: () => void;
    callbackOnChangeComments: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

const ReservationInfo = (props: ReservationInfoProps) => {
    return (
        <Box>
            {props.title && <SubTitle>{props.title}</SubTitle>}
            <HStack mb="0.5rem">
                <HStack
                    h="3.375rem"
                    w="14.438rem"
                    fontSize={"0.938rem"}
                    fontWeight="medium"
                    bg="#fafafa"
                    border={"1px"}
                    borderColor="#eeeeee"
                    borderRadius="md"
                    pl="1rem"
                >
                    {props.reservationDate ? (
                        <HStack>
                            <Text>
                                {convertDateReservation(
                                    Number.parseInt(props.reservationDate)
                                )}
                            </Text>
                            <Text
                                fontSize={"0.6rem"}
                                fontWeight="semibold"
                                color={"white"}
                                bg={props.isFace ? "mint.500" : "black"}
                                borderRadius="md"
                                px="4px"
                                py="3px"
                            >
                                {props.isFace ? "대면" : "비대면"}
                            </Text>
                        </HStack>
                    ) : (
                        <Text color="#bdbdbd">예약 일시를 선택해 주세요.</Text>
                    )}
                </HStack>
                <Input
                    h="3.375rem"
                    w="6rem"
                    fontSize={"0.875rem"}
                    fontWeight="semibold"
                    color={"#fff"}
                    bgColor="#000"
                    borderRadius="md"
                    type="button"
                    value={"예약등록"}
                    onClick={props.callbackReservation}
                />
            </HStack>
            <Textarea
                h="7.5rem"
                fontSize={"0.938rem"}
                fontWeight="medium"
                borderRadius="md"
                _placeholder={{ color: "#bdbdbd" }}
                placeholder="공동입구 번호, 요청사항을 입력해 주세요. (선택)"
                value={props.comments}
                onChange={props.callbackOnChangeComments}
            />
        </Box>
    );
};

export default ReservationInfo;
